import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Space,
  Select,
  Typography,
  Popover,
  Divider,
  DatePicker,
} from "antd";
import {
  LoginOutlined,
  PlayCircleFilled,
  ThunderboltOutlined,
  CloseOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import WorkspacePage from "../../Pages/Workspace/WorkspacePage";
import CheckInService from "../../Services/Manage/CheckInService";
import BreakTypeService from "../../Services/Manage/BreakTypeService";

const { Text, Title } = Typography;

const activityOptions = [
  { label: "Work", value: "work" },
  { label: "Meeting", value: "meeting" },
  { label: "Group Discussion", value: "group" },
  { label: "Available for collab", value: "collab" },
  { label: "Do not disturb", value: "donot_distrub" },
  { label: "Leave", value: "leave" },
];

const QuickAdd = () => {
  const [open, setOpen] = useState(false);
 
  const omeUser = JSON.parse(localStorage.getItem("ome_user"));
  const empUid = omeUser?.uid;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  return (
    <>
      <Space>

        <Button
          icon={<ThunderboltOutlined style={{ color: "#fa8c16" }} />}
          onClick={handleOpen}
          size="large"
        >
          Quick Add
        </Button>
      </Space>

      

      <Drawer
        title={
          <Title level={4} style={{ margin: 0 }}>
            Quick Add
          </Title>
        }
        placement="right"
        onClose={handleClose}
        open={open}
        width={520}
        bodyStyle={{ padding: 24, backgroundColor: "#fff" }}
      >
        <WorkspacePage handleClose={handleClose} singleColumn />
      </Drawer>
    </>
  );
};

export default QuickAdd;
